export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_REMOVE_ALL_ITEMS = 'CART_REMOVE_ALL_ITEMS';
export const CART_UPDATE_PRICE = 'CART_UPDATE_PRICE';
export const CART_LOAD_ALL_ITEMS = 'CART_LOAD_ALL_ITEMS';
export const RECALCULATE_SHIPPING = 'RECALCULATE_SHIPPING';
export const CHANGE_QTY = 'CHANGE_QTY';
